<template>
  <div class="flex flex-col space-y-2" :data-cy="`branding-${template.id}`">
    <div v-if="bgImage" class="image-template h-[64px] w-[90px] rounded-sm p-2">
      <div class="h-[6px] w-[20px] rounded-[1px] bg-white" />
      <div class="mt-4 h-[3px] w-[30px] rounded-[1px] bg-white" />
      <div class="mt-1 h-[3px] w-[40px] rounded-[1px] bg-white" />
      <div class="mt-3 flex items-center space-x-1">
        <div class="h-[5px] w-[5px] rounded-full bg-login-bg" />
        <div class="h-px w-[11px] rounded-[1px] bg-white" />
      </div>
    </div>
    <icon-base
      v-else
      :icon="IconEmailBrandingPreview"
      width="90"
      height="64"
      class="rounded-sm"
      :style="{
        color: template.header_primary_color || '',
      }"
    />

    <label class="flex cursor-pointer space-x-2">
      <input
        v-model="brandingModel"
        type="radio"
        :value="template.id"
        class="cursor-pointer"
      />
      <span class="-mt-0-25 break-all text-headline">
        {{ template.template_name }}
      </span>
    </label>
  </div>
</template>

<script setup lang="ts">
import { type PropType, computed } from "vue";

import IconEmailBrandingPreview from "@/components/icons/IconEmailBrandingPreview.vue";
import IconBase from "@/components/ui/IconBase.vue";

import type { IEmailCustomization } from "@/models/clients";

const props = defineProps({
  template: {
    type: Object as PropType<IEmailCustomization>,
    required: true,
  },
});

const brandingModel = defineModel<number | null>();

const bgImage = computed(() => {
  return props.template.header_image
    ? `url(${props.template.header_image})`
    : "";
});
</script>
<style scoped>
@reference "@/assets/tailwind.css";

.image-template {
  background-image: v-bind(bgImage);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
